export default {
  namespaced: true,
  state: {
    appLoading: false
  },
  getters: {
    appLoading(state) {
      return state.appLoading;
    }
  },
  mutations: {
    setLoading(state, loading) {
      state.appLoading = loading;
    }
  },
  actions: {
    setAppLoading({ commit }, loading) {
      commit('setLoading', loading);
    }
  }
};
